import React from 'react'
import { InlineNotification } from "../../../molecules/Notifications/InlineNotification/InlineNotification"
import { NotificationVariant } from "../../../../types/Notification"
import { constructMessage } from "./constructMessage"
import { ValidationError } from "yup"

/**
 * @memberof ValidationMessage
 * */
export const renderValidationError = (error: ValidationError) => {
    const isString = typeof error.message === 'string'
    const errorKey = isString ? error.message : (Object.keys(error.message)?.[0])
    const key = `validation-error-${error.path}-${errorKey}`
    return <InlineNotification
        key={key}
        variant={NotificationVariant.ERROR}
        message={constructMessage(error)}
        dismissable={false}
    />
}
